import Vue from "vue";
import Router from "vue-router";

import Artists from "@/components/Layout/Artists";
import Nikko from "@/components/Layout/Nikko";
import Kate from "@/components/Layout/Kate";
import PennyPinch from "@/components/Layout/PennyPinch";
import Efdot from "@/components/Layout/Efdot";
import Sam from "@/components/Layout/Sam";
import Pablo from "@/components/Layout/Pablo";
import DeGuzman from "@/components/Layout/DeGuzman";

Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior: function(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  linkExactActiveClass: "is-active",
  base: process.env.NODE_ENV === "production" ? "/artists/" : "/artists/",

  routes: [
    {
      path: "/",
      name: "artists",
      component: Artists,
    },
    {
      path: "/bhm",
      name: "nikko",
      component: Nikko,
    },
    {
      path: "/whm",
      name: "kate",
      component: Kate,
    },
    {
      path: "/pennypinch",
      name: "pennypinch",
      component: PennyPinch,
    },
    {
      path: "/efdot",
      name: "efdot",
      component: Efdot,
    },
    {
      path: "/samkirk",
      name: "samkirk",
      component: Sam,
    },
    {
      path: "/pabloserrano",
      name: "pablo",
      component: Pablo,
    },
    {
      path: "/louisdeguzman",
      name: "deguzman",
      component: DeGuzman,
    },
    {
      path: "/*",
      redirect: "/",
    },
  ],
});
